import React from 'react';
import { Outlet } from 'react-router-dom';
import { Wrap } from '@components';

const EventPage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default EventPage;
